import { gql } from "apollo-boost";

export const GET_PRODUCTS = gql`
  query Products(
    $limit: Int
    $skip: Int
    $orderBy: OrderByInput
    $where: ProductWhereInput
  ) {
    products(limit: $limit, skip: $skip, orderBy: $orderBy, where: $where) {
      data {
        image
        id
        name
        size
        detail
        barCode
        id
        size
        unit
        amount
        cfMessage
        originAmount
        originPrice
        promoPrice
        isPromo
        isPrinted
        commissionPlatforms {
          platform
          commissionType
          commissionValue
      }
        imageString
        note
        price
        currency
        priceUsd
        priceThb
        star
        sort
        priceLak
        creationDate
        expirationDate
        priceOptions {
          contain
          price
          unit
        }
        unitId {
          name
          id
        }
        brand {
          name
          id
        }
        brandName
        category {
          name
          id
        }
        categoryName
        subbrand {
          id
          name
        }
        subBrandName
        createdAt
        dimension{
          length
          width
          height
          weight
        }
        hasVariant
        isUsingSalePage
        survivalId {
          id
          survivalNumber
          note
          isDeleted
        }
        shippingCost
      }
      total
    }
  }
`;

export const HIDE_PRODUCT_OUT_OF_STOCK = gql`
query HideProductsOutOfStock($orderBy: OrderByInput, $skip: Int, $limit: Int, $where: ProductWhereInput) {
  hideProductsOutOfStock(orderBy: $orderBy, skip: $skip, limit: $limit, where: $where) {
    data {
        image
        id
        name
        size
        detail
        barCode
        id
        size
        unit
        amount
        cfMessage
        originAmount
        originPrice
        commissionPlatforms {
          platform
          commissionType
          commissionValue
      }
        note
        price
        promoPrice
        isPromo
        isPrinted
        currency
        priceUsd
        priceThb
        star
        sort
        priceLak
        creationDate
        expirationDate
        priceOptions {
          contain
          price
          unit
        }
        unitId {
          name
          id
        }
        brand {
          name
          id
        }
        brandName
        category {
          name
          id
        }
        categoryName
        subbrand {
          id
          name
        }
        subBrandName
        createdAt
        dimension{
          length
          width
          height
          weight
        }
        hasVariant
        isUsingSalePage
        survivalId {
          id
          survivalNumber
          note
          isDeleted
        }
        shippingCost
      }
      total
  }
}
`

export const ELASTICSEARCH_PRODUCT = gql`
query Data($limit: Int, $where: ProductWhereInput) {
  getProductElastisSearch(limit: $limit, where: $where) {
    data {
      id
      name
      amount
      price
      survivalId {
        id
        survivalNumber
      }
    }
  }
}
`;
export const GET_EXCHANGE_RATE = gql`
  query ExchangeRate($where: ExchangeRateWhereInput) {
    exchangeRate(where: $where) {
      baht
      id
      kip
      usd
      shop {
        id
        name
      }
    }
  }
`;

export const GET_PRODUCT_GENBARCODE = gql`
  query Products($where: ProductWhereInput) {
    products(where: $where) {
      total
    }
  }
`;

export const GET_PRODUCT_HISTORY = gql`
  query ProductHistories(
    $where: ProductHistoryWhereInput
    $orderBy: OrderByInput
    $skip: Int
    $limit: Int
  ) {
    productHistories(
      where: $where
      orderBy: $orderBy
      skip: $skip
      limit: $limit
    ) {
      total
      data {
        name
        updatedAt
        amount
        currency
        barCode
        unit {
          id
          name
        }
        category {
          name
          id
        }
        brand {
          name
          id
        }
      }
    }
  }
`;

export const SCAN_PRODUCT = gql`
  query StocksByBarcode($where: ScanBarcodeInput!) {
    stocksByBarcode(where: $where) {
      type
      product {
        _id
        name
        barCode
        price
        originPrice
        amount
        category { id name }
        brand { id name }
        image
        coverImages
        hasVariant
        isUsingSalePage
        currency
        cfMessage
        unit
        unitName
        size
        detail
        originAmount
        commissionPlatforms {
          platform
          commissionType
          commissionValue
        }
        note
        priceUsd
        priceThb
        star
        priceLak
        priceOptions {
          contain
          price
          unit
        }
        unitId {
          name
          id
        }
        brandName
        categoryName
        subbrand {
          id
          name
        }
        subBrandName
        createdAt
        dimension {
          length
          width
          height
          weight
        }
        survivalId {
          id
          survivalNumber
          note
          isDeleted
        }
      }
      productVariant {
        id
        barCode
        product{
        id
        name
        }
        price
        originPrice
        amount
        originAmount
        currency
        cfMessage
        image
        coverImages
        attributeValues { id value attribute { name } }
        note
        commissionPlatforms {
          platform
          commissionType
          commissionValue
        }
      }
    }
  }
`;

export const STOCK_ALMOST_GONES = gql`
  query StockAlmostGones($skip: Int, $limit: Int, $where: StockShopWhereInput) {
    stockAlmostGones(skip: $skip, limit: $limit, where: $where) {
      total
      data {
        name
        amount
        barCode
        _id
      }
    }
  }
`;

export const GET_PRODUCT_EXPIRE = gql`
  query Query($expireKey: String) {
    getProductExpire(expireKey: $expireKey)
  }
`;
